<template>
    <div class="filters">
        <app-sub-title text="Filtros" />
        <div class="card">
            <div class="card-body">
                <div class="card-text">
                    <b-row>
                        <b-col cols="12" md="3">
                            <app-form-select-input
                                label="Tipo"
                                :options="types"
                                v-model="filters.type"
                            />
                        </b-col>
                        <b-col cols="12" md="3">
                            <app-autocomplete
                                label="Destino"
                                :items="structures"
                                @change="onSelectStructure"
                            />
                        </b-col>
                        <b-col cols="12" md="2">
                            <app-form-text-input
                                label="Para"
                                v-model="filters.owner"
                            />
                        </b-col>
                        <b-col cols="12" md="2">
                            <app-form-text-input
                                type="date"
                                label="Desde"
                                v-model="filters.from"
                            />
                        </b-col>
                        <b-col cols="12" md="2">
                            <app-form-text-input
                                type="date"
                                label="Hasta"
                                v-model="filters.to"
                            />
                        </b-col>
                        <b-col cols="12" lg="1" offset-lg="10">
                            <b-btn
                                @click="onSearch"
                                variant="primary"
                                class="btn-block"
                            >
                                <i class="fa fa-filter"></i>
                            </b-btn>
                        </b-col>
                        <b-col cols="12" lg="1">
                            <b-btn
                                @click="onCancel"
                                variant="secondary"
                                class="btn-block"
                            >
                                <i class="fa fa-times-circle"></i>
                            </b-btn>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        types: {
            type: Array,
            required: true,
        },
        searchMails: {
            type: Function,
            required: true,
        },
        cancelFilter: {
            type: Function,
            required: true,
        },
        venueId: {
            type: Number,
        },
    },
    data() {
        return {
            filters: {
                type: '',
                destination: '',
                owner: '',
                from: '',
                to: '',
            },
            structures: [],
        }
    },
    computed: {
        ...mapGetters(['mailTypes']),
    },
    methods: {
        onSearch() {
            this.searchMails(this.filters)
        },
        onCancel() {
            this.cancelFilter()
        },
        clearFilters() {
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
        },
        onSelectStructure(structure) {
            if (!structure) return (this.filters.destination = '')
            this.filters.destination = structure.id
        },
        async loadStructures() {
            const venueId = !!this.accessPoint
                ? this.accessPoint.venue_id
                : !!this.venueId
                ? this.venueId
                : 0

            if (!venueId) return
            const { data } = await repo.get('structures', {
                venue: venueId,
            })
            this.structures = data
        },
    },
    created() {
        this.$bus.$on('delivered-mail-filters.clear', this.clearFilters)
    },
    mounted() {
        this.loadStructures()
    },
}
</script>
